var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',_vm._g(_vm._b({staticClass:"user-menu"},'v-menu',_vm.$attrs,false),_vm.$listeners),[_c('ng-list',{staticClass:"mx-n1",attrs:{"items":_vm.menuItems,"dense":""},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_vm._t("prepend")]},proxy:true},{key:"append",fn:function(){return [_vm._t("append")]},proxy:true}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }